/* eslint-disable no-restricted-globals, no-undef */
angular.module('resyApp')
  .constant('Config', {
    origin: `${location.protocol}//${location.host}`,
    baseUrl: `${location.protocol}//web.sandbox.resy.com/`,
    baseRequestUrl: 'https://api.sandbox.resy.com/',
    assetsBaseUrl: 'https://s3.amazonaws.com/assets.demo.resy.com/',
    apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
    automationApiKey: 'AIcdK2rLXG6TYwJseSbmrBAy3RP81ocd',
  })
  .constant('ItemsServiceConfig', {
    origin: `${location.protocol}//${location.host}`,
    baseUrl: `${location.protocol}//${location.host}/`,
    baseRequestUrl: 'https://item.sandbox.resy.com/',
  })
  .constant('AnnotationServiceConfig', {
    origin: `${location.protocol}//${location.host}`,
    baseUrl: `${location.protocol}//${location.host}/`,
    baseRequestUrl: 'https://annotation.sandbox.resy.com/',
  })
  .constant('ResyosServiceConfig', {
    origin: `${location.protocol}//${location.host}`,
    baseUrl: `${location.protocol}//${location.host}/`,
    baseRequestUrl: 'https://api.sandbox.resyos.com/',
  })
  .constant('ResyAmexConfig', {
    baseRequestUrl: 'https://d14rvb61uksiqz.cloudfront.net/',
    gdaEditorialApi: 'https://blog.resy.com/wp-json/wp/v2/',
    oneDataFunctionUrl: 'https://functions-dev.americanexpress.com',
  })
  .constant('ImageServiceConfig', {
    origin: `${location.protocol}//${location.host}`,
    baseUrl: `${location.protocol}//${location.host}/`,
    baseRequestUrl: 'https://image.sandbox.resy.com/',
  })
  .constant('SurveyServiceConfig', {
    origin: `${location.protocol}//${location.host}`,
    baseUrl: `${location.protocol}//${location.host}/`,
    baseRequestUrl: 'https://survey.sandbox.resy.com/',
  })
  .constant('TockConfig', {
    baseUrl: 'https://demo.exploretock.com/',
  })
  .constant('AutomationMode', document.cookie.includes('automation=true'))
  .constant('EventsCollectionId', 12);
